import {NextSeo, NextSeoProps} from 'next-seo';
interface SeoProps extends NextSeoProps {
    url?: string;
    images?: any[] | null;
    keywords?: string;
    canonical: string;
}
const Seo = ({title, description, images, url, keywords, canonical, ...props}: SeoProps) => {
    return (
        <NextSeo
            title={title}
            description={description}
            additionalMetaTags={[
                {
                    property: 'keywords',
                    content: keywords ?? '',
                },
            ]}
            openGraph={{
                ...(Boolean(url) && {
                    url: `${process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT}${url}`,
                }),
                title,
                description,
                ...(Boolean(images) && {
                    images: images?.map(item => ({
                        url: item?.image?.original,
                        alt: item?.title,
                    })),
                }),
            }}
            canonical={canonical}
            {...props}
        />
    );
};

export default Seo;
